import React from 'react';
import { CourseIcon } from './iconLibrary';

// Затемнение/осветление hex на процент (amt: -100..100)
export function shade(hex, amt) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
  const n = m ? parseInt(m[1], 16) : 0x7c4dff;
  let r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  const t = amt < 0 ? 0 : 255, p = Math.abs(amt) / 100;
  r = Math.round((t - r) * p) + r;
  g = Math.round((t - g) * p) + g;
  b = Math.round((t - b) * p) + b;
  return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('');
}

export const coverGradient = (color) => {
  const c = color || '#7c4dff';
  return `linear-gradient(135deg, ${shade(c, 12)} 0%, ${c} 45%, ${shade(c, -34)} 100%)`;
};

// Мягкая «плашка» цвета для фонов (полупрозрачный вариант)
export const coverSoft = (color) => `${color || '#7c4dff'}22`;

// Минималистичные macOS/SF-Symbols иконки на обложке: окно, play, лупа, папка, wifi, куб, курсор, терминал.
export const CoverPattern = ({ id }) => (
  <svg aria-hidden="true" width="100%" height="100%" style={{ position: 'absolute', inset: 0, color: 'var(--cc-pat)' }}>
    <defs>
      <pattern id={`ccp-${id}`} width="130" height="130" patternUnits="userSpaceOnUse" patternTransform="rotate(-6)">
        <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.13">
          {/* окно */}
          <g transform="translate(8,9)"><rect x="0" y="4" width="26" height="19" rx="4" /><path d="M0 10 h26" /></g>
          {/* play */}
          <g transform="translate(70,7)"><path d="M0 0 l14 8 l-14 8 z" /></g>
          {/* лупа */}
          <g transform="translate(102,10)"><circle cx="8" cy="8" r="8" /><path d="M13.7 13.7 l6 6" /></g>
          {/* куб */}
          <g transform="translate(40,38)"><path d="M11 0 l11 6 v13 l-11 6 l-11 -6 v-13 z" /><path d="M0 6 l11 6 l11 -6 M11 12 v13" /></g>
          {/* wifi */}
          <g transform="translate(92,42)"><path d="M0 8 a14 14 0 0 1 20 0" /><path d="M4 13 a9 9 0 0 1 12 0" /><circle cx="10" cy="19" r="1.6" fill="currentColor" stroke="none" /></g>
          {/* папка */}
          <g transform="translate(6,74)"><path d="M0 4 h9 l3 3 h14 a2.5 2.5 0 0 1 2.5 2.5 v11 a2.5 2.5 0 0 1 -2.5 2.5 h-26 a2.5 2.5 0 0 1 -2.5 -2.5 v-13.5 a2.5 2.5 0 0 1 2.5 -2.5 z" /></g>
          {/* терминал */}
          <g transform="translate(104,72)"><path d="M0 0 l6 5 l-6 5" /><path d="M10 12 h9" /></g>
          {/* курсор */}
          <g transform="translate(62,92)"><path d="M0 0 l0 22 l5 -6 l3.2 7.5 l3.4 -1.5 l-3.2 -7.5 l7.6 -0.8 z" /></g>
        </g>
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill={`url(#ccp-${id})`} />
  </svg>
);

export const CourseCover = ({ color, icon, size = 56, radius = 16, iconSize, className, style }) => (
  <div className={className}
    style={{
      width: size, height: size, borderRadius: radius, flexShrink: 0,
      background: coverGradient(color), color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      boxShadow: `0 10px 22px -10px ${color || '#7c4dff'}88`,
      ...style,
    }}>
    <CourseIcon icon={icon || 'zap'} size={iconSize || Math.round(size * 0.46)} sw={1.9} />
  </div>
);

export default CourseCover;
